<!-- Componente representa la información de la cabecera -->
<header>
  <!-- logo de la cabecera -->
    <div class="logo">
        <img src="assets/img/Logotipo_del_Ministerio_de_Sanidad.svg" alt="logotipo Ministerio de Sanidad">
    </div>
    <!-- Nombre de la aplicación -->
    <div class="appName">
        <a [routerLink]="['/']">
          <h1 >SIPRODI</h1>
        </a>
    </div>
    <div class="userMenu">
        <ng-container *ngIf="route.url == '/'" >
            <a [routerLink]="['/acceder']">Acceder</a>
        </ng-container>
        <span class="">{{roleString}}</span>
    </div>
  </header>
